export default "__VITE_ASSET__DuBeBWrz__"